const GcpLogo = (props) => {
  return (
    <svg
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2275 5.58665H15.3033L15.2584 5.55012L18.141 2.66466L18.1466 2.61409C15.7191 0.470368 12.3532 -0.268557 9.24863 0.66142C6.14683 1.59421 3.74462 4.06104 2.89331 7.18812C2.94669 7.16564 2.99727 7.14879 3.04784 7.13755C4.12111 6.43234 5.39385 6.02776 6.73684 6.01652C7.18638 6.01652 7.62749 6.05866 8.06016 6.14295C8.08264 6.1289 8.10231 6.12328 8.12198 6.1289C9.97631 4.08913 13.1006 3.85313 15.2415 5.58665H15.2275Z"
        fill="#EA4335"
      />
      <path
        d="M21.0179 7.18816C20.5375 5.42373 19.5541 3.83631 18.1858 2.62256L15.2582 5.55016C16.4944 6.55881 17.1968 8.0788 17.1687 9.67746V10.1944C20.6414 10.1944 20.6414 15.4062 17.1687 15.4062H11.9569L11.9485 15.4147V19.5504H11.926L11.9569 19.5813H17.1687C20.1582 19.6038 22.8048 17.668 23.6954 14.8134C24.5805 11.9617 23.4903 8.86268 21.0179 7.18816Z"
        fill="#4285F4"
      />
      <path
        d="M6.73677 19.5503H11.9486V15.3809H6.73677C6.36872 15.3809 6.00347 15.3022 5.66913 15.1477L2.65442 18.1596L2.646 18.1905C3.82603 19.0783 5.26173 19.5588 6.73677 19.5503Z"
        fill="#34A853"
      />
      <path
        d="M6.7368 6.01638C3.84572 6.03605 1.27775 7.88758 0.356199 10.6297C-0.570969 13.3747 0.353389 16.4035 2.64602 18.1651L5.67196 15.1448C4.00868 14.3918 3.60972 12.2172 4.89932 10.9276C6.18893 9.63796 8.36637 10.0341 9.11653 11.6974L12.1397 8.67426C10.8557 6.99412 8.85243 6.01076 6.7368 6.01638Z"
        fill="#FBBC05"
      />
    </svg>
  );
};

export default GcpLogo;
